const HTTP_URL = /^https?:\/\//i

/** Passes through `url` only if it's an http(s) URL; blocks javascript:/data: etc. */
export function safeHttpUrl(url: string | null | undefined): string | null {
  return url && HTTP_URL.test(url) ? url : null
}
